export default __webpack_public_path__ + "static/media/home2.810ed897.jpg";